// extracted by mini-css-extract-plugin
module.exports = {"pintxo-modal__header":"BaseModalHeader_pintxo-modal__header__wUElp","pintxo-modal__header__slot":"BaseModalHeader_pintxo-modal__header__slot__dv90X"};